// Traduções deste diálogo — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'shipments.shipmentDetailDialog.progress': 'Andamento',
    'shipments.shipmentDetailDialog.harvestStartReal': 'Início da colheita',
    'shipments.shipmentDetailDialog.fieldExitReal': 'Saída do campo',
    'shipments.shipmentDetailDialog.arrivalReal': 'Chegada na unidade',
    'shipments.shipmentDetailDialog.unloadEndReal': 'Fim da descarga',
    'shipments.shipmentDetailDialog.releasedReal': 'Liberação',
    'shipments.shipmentDetailDialog.eta': 'Previsão de chegada',
    'shipments.shipmentDetailDialog.documents': 'Documentos e composição',
    'shipments.shipmentDetailDialog.notStarted': 'Ainda não iniciada',
    'shipments.shipmentDetailDialog.shiftMorning': 'Manhã',
    'shipments.shipmentDetailDialog.shiftAfternoon': 'Tarde',
    'shipments.shipmentDetailDialog.shiftNight': 'Noite',
    'shipments.shipmentDetailDialog.selectDriverAndTruck': 'Selecione motorista e cavalo.',
    'shipments.shipmentDetailDialog.enterDate': 'Informe a data.',
    'shipments.shipmentDetailDialog.assignedSuccess': 'Carga atribuída.',
    'shipments.shipmentDetailDialog.assignLoad': 'Atribuir carga',
    'shipments.shipmentDetailDialog.driver': 'Motorista',
    'shipments.shipmentDetailDialog.searchDriver': 'Buscar motorista…',
    'shipments.shipmentDetailDialog.truck': 'Cavalo',
    'shipments.shipmentDetailDialog.searchVehicle': 'Buscar veículo…',
    'shipments.shipmentDetailDialog.optionalTrailer': 'Carreta opcional',
    'shipments.shipmentDetailDialog.searchTrailer': 'Buscar carreta…',
    'shipments.shipmentDetailDialog.date': 'Data',
    'shipments.shipmentDetailDialog.shift': 'Turno',
    'shipments.shipmentDetailDialog.searchShift': 'Buscar turno…',
    'shipments.shipmentDetailDialog.assign': 'Atribuir',
    'shipments.shipmentDetailDialog.dataUpdated': 'Dados atualizados.',
    'shipments.shipmentDetailDialog.statusUpdated': 'Status: {{status}}.',
    'shipments.shipmentDetailDialog.loadCancelled': 'Carga cancelada.',
    'shipments.shipmentDetailDialog.load': 'Carga',
    'shipments.shipmentDetailDialog.loadNumber': 'Carga {{number}}',
    'shipments.shipmentDetailDialog.contract': 'Contrato',
    'shipments.shipmentDetailDialog.origin': 'Origem',
    'shipments.shipmentDetailDialog.destination': 'Destino',
    'shipments.shipmentDetailDialog.trailer': 'Carreta',
    'shipments.shipmentDetailDialog.reassign': 'Reatribuir',
    'shipments.shipmentDetailDialog.assignDriverVehicle': 'Atribuir motorista e veículo',
    'shipments.shipmentDetailDialog.advanceTo': 'Avançar: {{status}}',
    'shipments.shipmentDetailDialog.cancelLoad': 'Cancelar carga',
    'shipments.shipmentDetailDialog.schedule': 'Cadência',
    'shipments.shipmentDetailDialog.harvestStartPlanned': 'Início da colheita previsto',
    'shipments.shipmentDetailDialog.fieldExitPlanned': 'Saída do campo prevista',
    'shipments.shipmentDetailDialog.arrivalPlanned': 'Chegada ao destino prevista',
    'shipments.shipmentDetailDialog.fiscalOperationalData': 'Dados fiscais e operacionais',
    'shipments.shipmentDetailDialog.fiscal.truckPlate': 'Placa do cavalo',
    'shipments.shipmentDetailDialog.fiscal.trailerPlate': 'Placa da carreta',
    'shipments.shipmentDetailDialog.fiscal.trip': 'Viagem',
    'shipments.shipmentDetailDialog.fiscal.ciot': 'CIOT',
    'shipments.shipmentDetailDialog.fiscal.invoice': 'Nota fiscal',
    'shipments.shipmentDetailDialog.fiscal.cteBatch': 'Nº do lote CT-e',
    'shipments.shipmentDetailDialog.fiscal.deviation': 'Desvio',
    'shipments.shipmentDetailDialog.fiscal.incident': 'Ocorrência',
    'shipments.shipmentDetailDialog.fiscal.scheduleStatus': 'Status da programação',
    'shipments.shipmentDetailDialog.fiscal.notes': 'Observações',
    'shipments.shipmentDetailDialog.saveData': 'Salvar dados',
  },
  en: {
    'shipments.shipmentDetailDialog.progress': 'Progress',
    'shipments.shipmentDetailDialog.harvestStartReal': 'Harvest start',
    'shipments.shipmentDetailDialog.fieldExitReal': 'Field exit',
    'shipments.shipmentDetailDialog.arrivalReal': 'Arrival at the unit',
    'shipments.shipmentDetailDialog.unloadEndReal': 'Unloading finished',
    'shipments.shipmentDetailDialog.releasedReal': 'Released',
    'shipments.shipmentDetailDialog.eta': 'Estimated arrival',
    'shipments.shipmentDetailDialog.documents': 'Documents and composition',
    'shipments.shipmentDetailDialog.notStarted': 'Not started yet',
    'shipments.shipmentDetailDialog.shiftMorning': 'Morning',
    'shipments.shipmentDetailDialog.shiftAfternoon': 'Afternoon',
    'shipments.shipmentDetailDialog.shiftNight': 'Night',
    'shipments.shipmentDetailDialog.selectDriverAndTruck': 'Select a driver and truck.',
    'shipments.shipmentDetailDialog.enterDate': 'Enter the date.',
    'shipments.shipmentDetailDialog.assignedSuccess': 'Load assigned.',
    'shipments.shipmentDetailDialog.assignLoad': 'Assign load',
    'shipments.shipmentDetailDialog.driver': 'Driver',
    'shipments.shipmentDetailDialog.searchDriver': 'Search driver…',
    'shipments.shipmentDetailDialog.truck': 'Truck',
    'shipments.shipmentDetailDialog.searchVehicle': 'Search vehicle…',
    'shipments.shipmentDetailDialog.optionalTrailer': 'Optional trailer',
    'shipments.shipmentDetailDialog.searchTrailer': 'Search trailer…',
    'shipments.shipmentDetailDialog.date': 'Date',
    'shipments.shipmentDetailDialog.shift': 'Shift',
    'shipments.shipmentDetailDialog.searchShift': 'Search shift…',
    'shipments.shipmentDetailDialog.assign': 'Assign',
    'shipments.shipmentDetailDialog.dataUpdated': 'Data updated.',
    'shipments.shipmentDetailDialog.statusUpdated': 'Status: {{status}}.',
    'shipments.shipmentDetailDialog.loadCancelled': 'Load cancelled.',
    'shipments.shipmentDetailDialog.load': 'Load',
    'shipments.shipmentDetailDialog.loadNumber': 'Load {{number}}',
    'shipments.shipmentDetailDialog.contract': 'Contract',
    'shipments.shipmentDetailDialog.origin': 'Origin',
    'shipments.shipmentDetailDialog.destination': 'Destination',
    'shipments.shipmentDetailDialog.trailer': 'Trailer',
    'shipments.shipmentDetailDialog.reassign': 'Reassign',
    'shipments.shipmentDetailDialog.assignDriverVehicle': 'Assign driver and vehicle',
    'shipments.shipmentDetailDialog.advanceTo': 'Advance to: {{status}}',
    'shipments.shipmentDetailDialog.cancelLoad': 'Cancel load',
    'shipments.shipmentDetailDialog.schedule': 'Schedule',
    'shipments.shipmentDetailDialog.harvestStartPlanned': 'Planned harvest start',
    'shipments.shipmentDetailDialog.fieldExitPlanned': 'Planned field departure',
    'shipments.shipmentDetailDialog.arrivalPlanned': 'Planned arrival at destination',
    'shipments.shipmentDetailDialog.fiscalOperationalData': 'Fiscal and operational data',
    'shipments.shipmentDetailDialog.fiscal.truckPlate': 'Truck license plate',
    'shipments.shipmentDetailDialog.fiscal.trailerPlate': 'Trailer license plate',
    'shipments.shipmentDetailDialog.fiscal.trip': 'Trip',
    'shipments.shipmentDetailDialog.fiscal.ciot': 'CIOT',
    'shipments.shipmentDetailDialog.fiscal.invoice': 'Invoice',
    'shipments.shipmentDetailDialog.fiscal.cteBatch': 'CT-e batch no.',
    'shipments.shipmentDetailDialog.fiscal.deviation': 'Deviation',
    'shipments.shipmentDetailDialog.fiscal.incident': 'Incident',
    'shipments.shipmentDetailDialog.fiscal.scheduleStatus': 'Scheduling status',
    'shipments.shipmentDetailDialog.fiscal.notes': 'Notes',
    'shipments.shipmentDetailDialog.saveData': 'Save data',
  },
  es: {
    'shipments.shipmentDetailDialog.progress': 'Avance',
    'shipments.shipmentDetailDialog.harvestStartReal': 'Inicio de la cosecha',
    'shipments.shipmentDetailDialog.fieldExitReal': 'Salida del campo',
    'shipments.shipmentDetailDialog.arrivalReal': 'Llegada a la unidad',
    'shipments.shipmentDetailDialog.unloadEndReal': 'Fin de la descarga',
    'shipments.shipmentDetailDialog.releasedReal': 'Liberación',
    'shipments.shipmentDetailDialog.eta': 'Llegada estimada',
    'shipments.shipmentDetailDialog.documents': 'Documentos y composición',
    'shipments.shipmentDetailDialog.notStarted': 'Aún no iniciada',
    'shipments.shipmentDetailDialog.shiftMorning': 'Mañana',
    'shipments.shipmentDetailDialog.shiftAfternoon': 'Tarde',
    'shipments.shipmentDetailDialog.shiftNight': 'Noche',
    'shipments.shipmentDetailDialog.selectDriverAndTruck': 'Selecciona un conductor y un camión.',
    'shipments.shipmentDetailDialog.enterDate': 'Indica la fecha.',
    'shipments.shipmentDetailDialog.assignedSuccess': 'Carga asignada.',
    'shipments.shipmentDetailDialog.assignLoad': 'Asignar carga',
    'shipments.shipmentDetailDialog.driver': 'Conductor',
    'shipments.shipmentDetailDialog.searchDriver': 'Buscar conductor…',
    'shipments.shipmentDetailDialog.truck': 'Camión',
    'shipments.shipmentDetailDialog.searchVehicle': 'Buscar vehículo…',
    'shipments.shipmentDetailDialog.optionalTrailer': 'Remolque opcional',
    'shipments.shipmentDetailDialog.searchTrailer': 'Buscar remolque…',
    'shipments.shipmentDetailDialog.date': 'Fecha',
    'shipments.shipmentDetailDialog.shift': 'Turno',
    'shipments.shipmentDetailDialog.searchShift': 'Buscar turno…',
    'shipments.shipmentDetailDialog.assign': 'Asignar',
    'shipments.shipmentDetailDialog.dataUpdated': 'Datos actualizados.',
    'shipments.shipmentDetailDialog.statusUpdated': 'Estado: {{status}}.',
    'shipments.shipmentDetailDialog.loadCancelled': 'Carga cancelada.',
    'shipments.shipmentDetailDialog.load': 'Carga',
    'shipments.shipmentDetailDialog.loadNumber': 'Carga {{number}}',
    'shipments.shipmentDetailDialog.contract': 'Contrato',
    'shipments.shipmentDetailDialog.origin': 'Origen',
    'shipments.shipmentDetailDialog.destination': 'Destino',
    'shipments.shipmentDetailDialog.trailer': 'Remolque',
    'shipments.shipmentDetailDialog.reassign': 'Reasignar',
    'shipments.shipmentDetailDialog.assignDriverVehicle': 'Asignar conductor y vehículo',
    'shipments.shipmentDetailDialog.advanceTo': 'Avanzar a: {{status}}',
    'shipments.shipmentDetailDialog.cancelLoad': 'Cancelar carga',
    'shipments.shipmentDetailDialog.schedule': 'Cadencia',
    'shipments.shipmentDetailDialog.harvestStartPlanned': 'Inicio previsto de la cosecha',
    'shipments.shipmentDetailDialog.fieldExitPlanned': 'Salida prevista del campo',
    'shipments.shipmentDetailDialog.arrivalPlanned': 'Llegada prevista al destino',
    'shipments.shipmentDetailDialog.fiscalOperationalData': 'Datos fiscales y operativos',
    'shipments.shipmentDetailDialog.fiscal.truckPlate': 'Placa del camión',
    'shipments.shipmentDetailDialog.fiscal.trailerPlate': 'Placa del remolque',
    'shipments.shipmentDetailDialog.fiscal.trip': 'Viaje',
    'shipments.shipmentDetailDialog.fiscal.ciot': 'CIOT',
    'shipments.shipmentDetailDialog.fiscal.invoice': 'Factura',
    'shipments.shipmentDetailDialog.fiscal.cteBatch': 'N.º del lote CT-e',
    'shipments.shipmentDetailDialog.fiscal.deviation': 'Desvío',
    'shipments.shipmentDetailDialog.fiscal.incident': 'Incidencia',
    'shipments.shipmentDetailDialog.fiscal.scheduleStatus': 'Estado de la programación',
    'shipments.shipmentDetailDialog.fiscal.notes': 'Observaciones',
    'shipments.shipmentDetailDialog.saveData': 'Guardar datos',
  },
}
